import { Select,Form, Space } from 'antd'
import React, {  useMemo } from 'react'
import { useFinanceSubTypeListQuery,} from '../../store/ReactWebSiteApi';
import SetBalanceType from './SetBalanceType';

function GetBalanceType(props) {
    const {data, isSuccess} = useFinanceSubTypeListQuery({
        efst_e_id:localStorage.getItem('e_id'),
        efst_finance_type_id:props.efst_finance_type_id,
        ect_name:props.ect_name,
        ect_mode:props.ect_mode,
        efst_state:'2'
    });
    
    const list = useMemo(() => {
        if(isSuccess && data && data.Status === 'success'){
            return data.Result.map((item) => {
                const {efst_id,efst_name,}=item;
                return {value:efst_id,label:efst_name}
            })
        }
        return []
    },[isSuccess, data])
    return (
        <>
            <Form.Item 
                label={props.label} 
                wrapperCol={props.wrapperCol} 
                required={props.required}          
                style={{marginBottom:"0"}}                  
            >
                <Space>
                    <Form.Item name={props.name}    >
                        <Select 
                            options={list} 
                            onChange={(e,f) => {
                                console.log(e,f);
                                props.getBalanceType(f.value,f.label)
                            }}
                            defaultValue={props.defaultId}
                            placeholder={props.defaultId}
                            style={{width:'300px'}}
                        />
                    </Form.Item>
                    <SetBalanceType efst_finance_type_id={props.efst_finance_type_id} title={props.title+'类型'}/>
                </Space>
            </Form.Item>
        </>
    )
}

export default GetBalanceType